import config from "@/config";

// Progress of a deposit's latest ingest, set in its metadata file by the
// ingest workflow (see workflow-ingest-deposits)
const INGEST_STATUSES = {
  submitted: { label: "Ingesting", color: "info", icon: "mdi-progress-clock" },
  ingested: { label: "Ingested", color: "success", icon: "mdi-check-circle" },
  failed: { label: "Ingest failed", color: "error", icon: "mdi-alert-circle" },
};

// Display details for the deposit's ingest status, or null if there isn't one
export function ingestStatusOf(deposit) {
  return INGEST_STATUSES[deposit?.ingestStatus] ?? null;
}

// The Workbench URL for viewing the deposit's ingested package, or null.
// The metadata file isn't only written by the ingest workflow, so only links to
// a package in this environment's Workbench are returned.
export function workbenchUrlOf(deposit, workbenchBaseUrl = config.workbenchBaseUrl) {
  if (deposit?.ingestStatus !== "ingested" || !deposit.workbenchUrl || !workbenchBaseUrl) return null;
  try {
    const url = new URL(deposit.workbenchUrl);
    const base = new URL(workbenchBaseUrl);
    const isPackage = url.protocol === "https:"
      && url.origin === base.origin
      && /^\/repository\/packages\/[^/]+$/.test(url.pathname);
    return isPackage ? url.href : null;
  } catch {
    return null;
  }
}
